import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Project } from '@ops/shared-types';
import { Subscription } from 'rxjs';

export type ExpensePage = 'invoices' | 'expenses';

@Component({
  selector: 'app-project-expenses',
  templateUrl: './project-expenses.component.html',
  styleUrls: ['./project-expenses.component.scss'],
})
export class ProjectExpensesComponent implements OnInit, OnDestroy {
  @Input() project: Project;
  @Input() isInPayments = false;
  selectedPage: ExpensePage;
  pages: { type: ExpensePage; value: string }[] = [];
  private translationSubscription: Subscription;

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    this.loadTranslations();

    // Listen for language changes
    this.translationSubscription = this.translate.onLangChange.subscribe(() => {
      this.loadTranslations();
    });
  }

  ngOnDestroy(): void {
    if (this.translationSubscription) {
      this.translationSubscription.unsubscribe();
    }
  }

  private loadTranslations(): void {
    // Clear existing pages to avoid duplicates
    this.pages = [];

    this.translate
      .get([
        'projectEstimate.payments.expenses.estimatesAndInvoices',
        'projectEstimate.payments.expenses.projectExpenseOverview',
      ])
      .subscribe((translations) => {
        this.pages.push({
          type: 'invoices',
          value:
            translations[
              'projectEstimate.payments.expenses.estimatesAndInvoices'
            ],
        });
        this.pages.push({
          type: 'expenses',
          value:
            translations[
              'projectEstimate.payments.expenses.projectExpenseOverview'
            ],
        });
      });

    this.selectedPage = 'invoices';
  }

  selectPage(page: ExpensePage) {
    this.selectedPage = page;
  }
}
